import { html } from 'rune-ts';
import { BaseButtonAction, BaseButtonProps } from './BaseButtonAction';

export interface LimitedQuantityButtonProps extends BaseButtonProps {
  quantity: number;
  show_quantity_limit?: boolean;
}

export class LimitedQuantityButtonAction extends BaseButtonAction<LimitedQuantityButtonProps> {
  protected override makeType(): BaseButtonProps['type'] {
    return 'blue';
  }

  protected override makeLabel() {
    return this.data.show_quantity_limit
      ? html`
          <b>${this.data.label || ET('cta::limited')}</b>
          <div data-is-limited>${ET('cta::quantity', { quantity: this.data.quantity })}</div>
        `
      : html`<b>${this.data.label || ET('cta::limited_not_show_count')}</b>`;
  }
}
